import { createMapOfSet } from '../../../../shared';
/**
 * This function calculates which item to check / un-check, if shift is pressed all items
 *  between the last checked and the selected are checked / unchecked
 * @param currentCheckedIds Currently checked ids
 * @param currentIds All ids in the list
 * @param toggledId New id that was toggled
 * @returns An array of items to check and an array of items to un-check
 */
export function calculateMultiCheckChanges(
    currentCheckedIds: string[],
    currentIds: string[],
    toggledId: string
): { toUncheck: string[]; toCheck: string[] } {
    // Here comes the logic when there is something already checked
    const itemsToCheck: string[] = [];
    const itemsToUncheck: string[] = [];

    const currentCheckedIdsMap = createMapOfSet(currentCheckedIds);
    // Check everything from last checked item to one which is clicked/toggled (if they are not already checked)

    const lastCheckedItemId = currentCheckedIds[currentCheckedIds.length - 1];
    const lastCheckedIndex = currentIds.findIndex(item => item === lastCheckedItemId);
    const toggledItemIndex = currentIds.findIndex(item => item === toggledId);

    let startIndex = lastCheckedIndex;
    let endIndex = toggledItemIndex;

    if (toggledItemIndex < lastCheckedIndex) {
        startIndex = toggledItemIndex;
        endIndex = lastCheckedIndex;
    }

    let areNewItemsChecked = false;

    for (let index = startIndex; index <= endIndex; index++) {
        const item = currentIds[index];

        if (!currentCheckedIdsMap[item]) {
            itemsToCheck.push(item);
            areNewItemsChecked = true;
        }
    }

    // If all the items between last and clicked are already check -> uncheck all the items between
    if (!areNewItemsChecked) {
        for (let index = startIndex; index <= endIndex; index++) {
            const item = currentIds[index];

            if (currentCheckedIdsMap[item]) {
                itemsToUncheck.push(item);
            }
        }
    }

    return {
        toCheck: itemsToCheck,
        toUncheck: itemsToUncheck,
    };
}

export function calculateSingleCheckChanges(
    currentCheckedIds: string[],
    toggledId: string
): { toUncheck: string[]; toCheck: string[] } {
    const isItemAlreadyChecked = currentCheckedIds.some(item => item === toggledId);
    return {
        toUncheck: isItemAlreadyChecked ? [toggledId] : [],
        toCheck: isItemAlreadyChecked ? [] : [toggledId],
    };
}
